import cardValidator from 'card-validator'

import { logAndCaptureException } from '../../utils/errorTools'
import { CardTypeInvalidError } from '../cart/errors'

/**
 * Credit card types mapped to Cybersource types in Magedelight extension
 */
export type MagentoCyberSourceCardType =
  | 'AE'
  | 'DC'
  | 'DI'
  | 'JCB'
  | 'MAESTRO'
  | 'MC'
  | 'SWITCH'
  | 'VI'

/**
 * Map of card types from `credit-card-type` NPM module to M2 CyberSource
 */
const cardTypeMapping: Record<string, MagentoCyberSourceCardType> = {
  'american-express': 'AE',
  'diners-club': 'DC',
  discover: 'DI',
  jcb: 'JCB',
  maestro: 'MAESTRO',
  mastercard: 'MC',
  visa: 'VI',
}

export const cardTypeFromCardNumber = (
  cardNumber: string,
): MagentoCyberSourceCardType | undefined => {
  const { card: validatedCard } = cardValidator.number(cardNumber)
  if (!validatedCard) {
    return undefined
  }

  const mappedType = cardTypeMapping[validatedCard.type]
  if (!mappedType) {
    logAndCaptureException(new Error(`Card type not mapped: ${validatedCard.type}`))
    return undefined
  }
  return mappedType
}

export const cardTypeFromCardNumberResult = (
  cardNumber: string,
): { _tag: 'Left'; error: Error } | { _tag: 'Right'; data: MagentoCyberSourceCardType } => {
  const { card: validatedCard } = cardValidator.number(cardNumber)
  if (!validatedCard) {
    return { _tag: 'Left', error: new CardTypeInvalidError(`Invalid card number`) }
  }

  const mappedType = cardTypeMapping[validatedCard.type]
  if (!mappedType) {
    return {
      _tag: 'Left',
      error: new CardTypeInvalidError(`Card type not mapped: ${validatedCard.type}`),
    }
  }
  return { _tag: 'Right', data: mappedType }
}
